<div style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
  <span style="display: block; font-size: 0.75rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; text-align: center; margin-bottom: 14px;">Tipo de cambio</span>
  <div style="display: flex; align-items: center; justify-content: center; gap: 12px;">
    <!-- USDT -->
    <div style="display: flex; align-items: center; gap: 8px; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 10px 16px; border-radius: 12px;">
      <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;">
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280;">USDT</span>
        <p style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">1.00</p>
      </div>
    </div>

    <!-- Flecha -->
    <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D; flex-shrink: 0;">arrow_forward</mat-icon>

    <!-- CLP -->
    <div style="display: flex; align-items: center; gap: 8px; background: #eff6ff; border: 1px solid #bfdbfe; padding: 10px 16px; border-radius: 12px;">
      <img src="assets/flags/chile.png" alt="CLP" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;">
      <div>
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280;">CLP</span>
        <p style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #2563eb;">{{ usdt_clp_tax | number:'1.0-2' }}</p>
      </div>
    </div>
  </div>
  <img *ngIf="!hasLoaded" src="assets/loader.svg" height="40" width="40" style="margin: 10px auto 0; display: block;" alt="Cargando">
</div>
